module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a6b0f453205a7ff228cfba107ee5b97d.png";